import { CustomFieldType } from './custom-field-type.enum';
var MultilevelCustomFieldBuilder = /** @class */ (function () {
    function MultilevelCustomFieldBuilder() {
        this.customField = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            name: 'bob-bob-bob',
            displayName: 'Bob',
            creationDate: Date.now(),
            lastUpdateDate: Date.now(),
            type: CustomFieldType.MULTI_LEVEL,
            data: {
                enabledLocales: ['en'],
                fieldLevels: [
                    {
                        title: 'Bob',
                        translatedTitles: {},
                    }
                ],
                publiclyVisible: true,
                values: [],
            },
        };
    }
    MultilevelCustomFieldBuilder.prototype.withId = function (id) {
        this.customField.id = id;
        return this;
    };
    MultilevelCustomFieldBuilder.prototype.withName = function (name) {
        this.customField.name = name;
        return this;
    };
    MultilevelCustomFieldBuilder.prototype.withDisplayName = function (displayName) {
        this.customField.displayName = displayName;
        return this;
    };
    MultilevelCustomFieldBuilder.prototype.withData = function (data) {
        this.customField.data = data;
        return this;
    };
    MultilevelCustomFieldBuilder.prototype.withDataValues = function (values) {
        this.customField.data.values = values;
        return this;
    };
    MultilevelCustomFieldBuilder.prototype.withCreationDate = function (creationDate) {
        this.customField.creationDate = creationDate;
        return this;
    };
    MultilevelCustomFieldBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.customField.lastUpdateDate = lastUpdateDate;
        return this;
    };
    MultilevelCustomFieldBuilder.prototype.build = function () {
        return this.customField;
    };
    return MultilevelCustomFieldBuilder;
}());
export { MultilevelCustomFieldBuilder };
//# sourceMappingURL=multilevel-custom-field.builder.js.map